module.exports = __webpack_public_path__ + "static/media/Philip-Morris-PMI-Logo.d963aa37.png";